export default "__VITE_ASSET__JyGGz5hM__"